import { api } from '@/core/api/';

export default {
  getServiceLocations(companyId, params) {
    return api.get('api/servicelocations/list/' + companyId, { params });
  },
  getDisciplinesList(providerId, locationId, serviceTypeId) {
    return api.get(`api/servicelocations/disciplinelist/${providerId}/${locationId}/${serviceTypeId}`);
  },
};
